export default __webpack_public_path__ + "static/px9-2f127f1db3a6fc30d628d60d101a4bd7.jpg";